import React from "react";
import styled from "@emotion/styled";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

const getTableCellWidths = (cellCount: number) => {
  if (cellCount === 2) {
    return ["30%", "70%"];
  }
  if (cellCount === 3) {
    return ["30%", "35%", "35%"];
  }
  // For more than 3 columns, adjust the widths as needed
  const firstWidth = "30%";
  const remainingWidth = 70 / (cellCount - 1);
  const widths = [
    firstWidth,
    ...Array(cellCount - 1).fill(`${remainingWidth}%`),
  ];
  return widths;
};

interface CustomTableCellProps {
  width: string;
}

const CustomTableCell = styled(TableCell)<CustomTableCellProps>(
  ({ width }) => ({
    border: "1px solid #dbdbdb",
    padding: "4px 16px",
    width: width,
  })
);

const FirstColumnTableCell = styled(CustomTableCell)({
  backgroundColor: "#eeecef",
  fontWeight: 600,
});



interface DetailsCardProps {
  rows: Array<{ id: string; value: string | JSX.Element }>;
}
const DetailsCard: React.FC<DetailsCardProps> = ({rows}) => {
  return (
    <TableContainer sx={{marginBottom:'16px'}} component={Paper}>
      <Table>
        <TableBody sx={{ border: "3px solid #dbdbdb" }}>
          {rows.map((row, index) => {
            const rowData = Object.values(row);
            const cellCount = rowData.length;
            const widths = getTableCellWidths(cellCount);

            return (
              <TableRow key={index}>
                {rowData.map((cellData, cellIndex) => {
                  const isFirstColumn = cellIndex === 0;
                  const CellComponent = isFirstColumn
                    ? FirstColumnTableCell
                    : CustomTableCell;
                  return (
                    <CellComponent key={cellIndex} width={widths[cellIndex]}>
                      {cellData}
                    </CellComponent>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DetailsCard;